"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchMain = void 0;
function dispatchMain(action) {
    return {
        type: "DispatchMain",
        action: action,
    };
}
exports.dispatchMain = dispatchMain;
//# sourceMappingURL=root-actions.js.map